import React, {useEffect, useState} from 'react';
import styles from '../styles/actionsList.module.scss';
import commonStyles from '../styles/list.module.scss';
import {Scrollbar} from '@priority-software/priority-style-react';
import {isRTL} from '../../../Localization';
import {Item} from './Item';
import {DraggableItem} from './DraggableItem';
import {reorder} from '../utils/dnd';
import {DraggableList} from '../../../components/commonOldtoNew';
import {getFieldMenuData} from '../utils/submenu';
import {ActionsSubtitle} from './ActionsSubtitle';
import {ActionsSubtitleType} from '../consts';

export const ActionsList = ({
    data,
    updateData,
    setSelectedItems,
    selectedItems,
    foundItemName,
    viewItemName,
    packages,
    setPackages
}) => {
    const [list, setList] = useState([]);

    useEffect(() => {
        const clone = Array.from(data);
        data?.length && clone.splice(2, 0, getPlaceholder());
        setList(clone);
    }, [data]);

    const onDragUpdate = update => {
        const {destination, source} = update;
        if (destination) {
            let res;
            const placeholderIndex = list.findIndex(i => isPlaceholder(i));
            // we are dragging an item that is orginated from the upper part
            if (source.index < 2) {
                //initial drag from the upper part to the lower part
                if (destination.index > 2 && placeholderIndex === 2) {
                    res = reorder(list, placeholderIndex, 3);
                }
                // dragging back from the lower to the upper without dropping
                if (destination.index < 2 && placeholderIndex === 3) {
                    res = reorder(list, placeholderIndex, 2);
                }
            }
            // we are dragging an item that is orginated from the lower part
            if (source.index > 2) {
                // dragging back from the lower to the upper without dropping
                if (destination.index < 2 && placeholderIndex === 2) {
                    res = reorder(list, placeholderIndex, 1);
                }
                // dragging back from the upper to the lower without dropping
                if (destination.index > 2 && placeholderIndex === 1) {
                    res = reorder(list, placeholderIndex, 2);
                }
            }
            res && setList(res);
        }
    };

    const onDragEnd = result => {
        setList(result);
        updateData(result.filter(i => !isPlaceholder(i)));
    };

    const onUpdate = () => {
        updateData(list.filter(i => !isPlaceholder(i)));
    };

    return (
        <Scrollbar componentClasses={commonStyles.scrollbar} rtl={isRTL()}>
            {list && list.length > 0 && (
                <ActionsSubtitle actionsSubtitleType={ActionsSubtitleType.quickAccess} />
            )}
            <DraggableList
                componentClasses={commonStyles.list}
                data={list}
                onDragUpdate={onDragUpdate}
                handleDNDFinish={onDragEnd}
                renderItem={({item, index, ...dragProps}) => (
                    <DraggableItem
                        {...dragProps}
                        key={item?.ID}
                        componentClasses={styles.draggableWrapper}
                    >
                        {isPlaceholder(item) ? (
                            <ActionsSubtitle
                                actionsSubtitleType={ActionsSubtitleType.actionsList}
                            />
                        ) : (
                            <Item
                                item={item}
                                isFound={foundItemName === item.Name}
                                isViewItem={viewItemName.includes(item.Name)}
                                setSelectedItems={setSelectedItems}
                                selectedItems={selectedItems}
                                onUpdate={onUpdate}
                                menuData={getFieldMenuData(
                                    item,
                                    null,
                                    false,
                                    packages.find(p => p.PackageId === item.PackageId)
                                )}
                                pack={packages.find(p => p.PackageId === item.PackageId)}
                                packages={packages}
                                setPackages={setPackages}
                                data={list}
                                {...dragProps}
                            />
                        )}
                    </DraggableItem>
                )}
            />
        </Scrollbar>
    );
};

const getPlaceholder = () => {
    return {placeholder: true};
};

const isPlaceholder = item => {
    return item.placeholder;
};
